module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "test"
    }
  }, [_c('button', {
    on: {
      "click": _vm.test
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa4cf7ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/_test.vue
// module id = 200
// module chunks = 2